<template>
  <div class="container">
    <div class="ps-4 py-3 text-center">
      <h3>โครงการ {{ campaign.TITLE }}</h3>
    </div>
    <div class="text-center py-2">
      <span class="fs-4 ps-3 text-danger">กรุณาอย่าส่งต่อQR Code ให้ผู้อื่น</span>
    </div>
    <div class="alert alert-success" role="alert" v-if="isDonate">ได้รับเงินบริจาคแล้ว</div>
    <div class="d-flex justify-content-center" v-if="isLoading">
      <div class="spinner-border text-secondary" style="width: 3rem; height: 3rem" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      Loading...
    </div>
    <div v-else class="">
      <div class="row">
        <div class="col-xl-3">
          <div class="d-flex justify-content-center">
            <!-- ยืนยันแล้วว่าเงินเข้า ต้องเอา QR ออกจากจอทันที ผู้บริจาคที่เข้าใจว่า
                 ครั้งแรกไม่ผ่านจะสแกนใบเดิมที่ยังค้างอยู่ซ้ำ เกิดขึ้นจริงมาแล้ว
                 (donateid 12444/12445 จ่ายซ้ำห่างกัน 3.4 นาที เป็นเงิน 5,000 บาท)
                 และห้ามตกไปที่กล่อง error เพราะปุ่ม "ลองใหม่" จะสร้าง QR ใบใหม่ให้อีก -->
            <div
              v-if="showStatusBox"
              class="d-flex flex-column justify-content-center align-items-center border rounded text-center p-3"
              style="width: 300px; height: 300px"
            >
              <font-awesome-icon
                :icon="['fas', 'check']"
                size="2xl"
                style="color: #20c10b"
                class="mb-3"
              />
              <div class="fw-bold">{{ statusBoxTitle }}</div>
              <div class="small text-muted mt-2">ไม่ต้องชำระเงินซ้ำอีก</div>
              <div v-if="isAttachSlipMode" class="small text-muted mt-2">
                กรุณาแนบสลิปของรายการเดิมทางด้านขวา
              </div>
            </div>
            <!-- v-if กัน <img src=""> ซึ่งเป็นต้นตอของอาการ "กล่องขาว"/"ตัวหนังสือ Image"
                 ที่ WebKit แต่ละเวอร์ชันวาดไม่เหมือนกัน ดู docs/donate-qr-image-bug.md -->
            <img
              v-else-if="imageSrc"
              :src="imageSrc"
              style="width: 300px; height: 300px"
              alt="QR Code สำหรับชำระเงิน"
              @click="saveQRCode"
              @error="onQRImageError"
            />
            <div
              v-else
              class="d-flex flex-column justify-content-center align-items-center border rounded text-center p-3"
              style="width: 300px; height: 300px"
            >
              <font-awesome-icon
                icon="fa-solid fa-xmark"
                size="2xl"
                style="color: #e94016"
                class="mb-3"
              />
              <div class="fw-bold">{{ qrError || 'ไม่สามารถแสดง QR Code ได้' }}</div>
              <!-- "ลองใหม่อีกครั้ง" ใช้ได้เฉพาะกับ QR ที่สร้างไม่สำเร็จ ถ้าแถวผู้บริจาคยัง
                   ไม่เกิด การลองใหม่ไม่ได้ช่วยอะไรเลย ต้องกลับไปกรอกข้อมูลใหม่เท่านั้น -->
              <div v-if="donorSaveFailed" class="small text-muted mt-2">
                กรุณาเริ่มรายการใหม่ตั้งแต่ต้น แล้วชำระเงินหลังจาก QR ขึ้นบนหน้าจอนี้เท่านั้น
              </div>
              <div v-else class="small text-muted mt-2">กรุณาลองใหม่อีกครั้ง</div>
            </div>
          </div>
          <div class="d-grid gap-2 mt-1" v-if="!showStatusBox">
            <button v-if="imageSrc" class="btn btn-primary" @click="saveQRCode">
              บันทึกรูป QR
            </button>
            <!-- ห้ามให้ปุ่มนี้โผล่ตอนแถวผู้บริจาคยังไม่เกิด — retryQRCode() เรียก setupQRCode()
                 ซึ่งสาย e-Donation จะแปะรูป QR นิ่งขึ้นจอทันทีโดยไม่สนว่า insert ล้มไปแล้ว
                 กลายเป็นคำเชิญให้จ่ายเงินเข้ารายการที่ไม่มีอยู่จริง เกิดขึ้นแล้ว 15 ส.ค. 2026
                 (10,000 บาท ไม่มีแถวรองรับ) ดู docs/open-items.md §2.2 -->
            <button
              v-else-if="donorSaveFailed"
              class="btn btn-warning"
              @click="restartDonation"
            >
              เริ่มรายการใหม่
            </button>
            <button v-else class="btn btn-warning" @click="retryQRCode">ลองใหม่อีกครั้ง</button>
          </div>
          <!-- iOS ทุกเวอร์ชันบันทึกรูปด้วยการกดค้างได้ ไม่ต้องพึ่ง Web Share API -->
          <div v-if="imageSrc && !showStatusBox" class="small text-muted text-center mt-1">
            บนมือถือ กดปุ่มแล้วเลือก "บันทึกรูปภาพ" หรือกดค้างที่รูป
          </div>
        </div>
        <div class="col-xl-auto"></div>
        <div class="col-xl-6">
          <div>
            ยอดที่ท่านต้องการบริจาค
            <span class="fw-bold fs-4 text text-success">{{ formatPrice(donateAmount) }}</span> บาท.
          </div>
          <div class="mt-2">
            <div class="d-flex align-items-center">
              <div class="input-group">
                <input
                  class="form-control"
                  type="file"
                  name="slipFile"
                  id="slipFile"
                  @change="onFileSelected"
                  :disabled="disableUpload"
                />
                <button class="btn btn-success" @click="onUpload" :disabled="isFileEmpty">
                  <font-awesome-icon icon="cloud-arrow-up" /> Upload slip
                </button>
              </div>
              <div class="ps-2" v-if="uploadProgressNumber === '100%'">
                <div v-if="uploadSlipStatus === 'success'">
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    beat
                    size="2xl"
                    style="color: #20c10b"
                  />
                </div>
                <div v-else-if="uploadSlipStatus === 'error'">
                  <font-awesome-icon
                    icon="fa-solid fa-xmark"
                    beat
                    size="2xl"
                    style="color: #e94016"
                  />
                </div>
              </div>
            </div>
            <!-- ไอคอนกากบาทข้างบนโผล่เฉพาะตอน uploadProgressNumber === '100%'
                 ความผิดพลาดที่เกิดก่อนยิง request จึงไม่มีอะไรแสดงเลย ต้องมีข้อความแยก -->
            <div v-if="uploadError" class="text-danger small pt-2">{{ uploadError }}</div>
            <div v-if="isUploadSlip" class="pt-2">
              <div
                class="progress"
                role="progressbar"
                aria-label="Basic example"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-bar" :style="uploadProgress">{{ uploadProgressNumber }}</div>
              </div>
            </div>
          </div>
          <div class="pt-3" v-if="showStatusBox">ขอขอบคุณ สำหรับการสนับสนุน</div>
        </div>
        <div class="col-xl-auto"></div>
      </div>
    </div>
    <div class="pt-5"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useCookies } from 'vue3-cookies';
import { useCrypto } from '../components/scripts/useCrypto';
import { usePayment } from '../components/scripts/usePayment';
import { useClientLog } from '../components/scripts/useClientLog';
import { useSaveImage } from '../components/scripts/useSaveImage';
import { useDonor } from '../components/scripts/useDonor';
import { useCampaigns } from '../components/scripts/useCampaigns';
import { formatPrice } from '../components/scripts/utillities';

const router = useRouter();
const { cookies } = useCookies();
const { decryptData } = useCrypto();
const {
  imageSrc,
  isLoading,
  qrError,
  failQRCode,
  createQRCode,
  createEdonatQrcode,
  getBiller,
  paymentCheck,
  uploadSlip
} = usePayment();
const { describeImageSrc } = useClientLog();
const { saveImage } = useSaveImage();
const { insertDonorToDB } = useDonor();
const { Campaigns } = useCampaigns();

const donateInfo = ref({});
const isDonate = ref(false);
const donateAmount = ref(0);
const selectedFile = ref(null);
const isUploadSlip = ref(false);
const uploadSlipStatus = ref('success');
const uploadError = ref('');
const uploadProgress = ref('');
const uploadProgressNumber = ref(0);
const isEdonation = ref(false);
const disableUpload = ref(true);
// แถวผู้บริจาคยังไม่เกิดในฐานข้อมูล — ต่างจาก "สร้าง QR ไม่สำเร็จ" ตรงที่ลองใหม่ไม่ช่วย
// และห้ามแสดง QR ใดๆ ทั้งสิ้น เพราะเงินที่เข้ามาจะไม่มีรายการรองรับ
const donorSaveFailed = ref(false);
// ผลของ Repeat Intent Check ที่ผู้บริจาคเลือกไว้ที่หน้าก่อนหน้า อ่านจากคุกกี้ donate_info
// การรีเฟรชหน้านี้จึงยังอยู่โหมดเดิม และถ้าคุกกี้หมดอายุ ข้อความ "เซสชันหมดอายุ" เดิม
// จะพากลับไปเริ่มรายการใหม่ ซึ่งจะเจอโมดัลเดิมอีกรอบพอดี — ไม่ต้องมี flow กู้คืนแยก
const repeat = ref(null);
let paymentInterval = null;

// แนบสลิปให้ Donation เดิมที่มีอยู่แล้ว — Settled (Retroactive Slip) หรือ Awaiting Review
// ที่ผู้บริจาคขอแนบไฟล์ใหม่ทับ ดู CONTEXT.md
const isAttachSlipMode = computed(() => repeat.value?.mode === 'attach_slip');

// กล่องสถานะแทนที่ QR ต้องพูดตามความจริงของแต่ละกรณี — บอกว่า "ได้รับเงินแล้ว" กับคนที่
// สลิปยังรอตรวจอยู่ คือการยืนยันสิ่งที่ยังไม่มีใครยืนยัน ซึ่งขัดกับหลักทั้งหมดใน ADR 0001
const isAwaitingReview = computed(() => repeat.value?.shownAction === 'awaiting_review');
const showStatusBox = computed(() => isDonate.value || isAttachSlipMode.value);
const statusBoxTitle = computed(() =>
  isAttachSlipMode.value && isAwaitingReview.value
    ? 'สลิปของท่านอยู่ระหว่างการตรวจสอบ'
    : 'ได้รับเงินบริจาคของท่านแล้ว'
);

const campaign = computed(() => {
  return Campaigns.value.find((c) => c.ID == donateInfo.value.campaignID) || { TITLE: 'บริจาคให้มหาวิทยาลัยทักษิณ' };
});

const isFileEmpty = computed(() => !selectedFile.value);

const onFileSelected = (event) => {
  selectedFile.value = event.target.files[0];
};

const onUpload = async () => {
  uploadError.value = '';

  // คุกกี้ isDonate อายุ 30 นาที ส่วน polling รอ callback ได้ถึง 15 นาที คนที่ได้รับ
  // การยืนยันช้าแล้วหาไฟล์สลิปนานจึงกดปุ่มตอนคุกกี้หมดอายุได้จริง เดิมโค้ดอ่าน
  // .donorid นอก try พอคุกกี้เป็น null จึง TypeError ตั้งแต่ยังไม่ยิง request
  // catch ด้านล่างรับไม่ทัน ผู้ใช้เห็นแค่ปุ่มที่กดแล้วเงียบ
  const isDonateCookie = cookies.get('isDonate');
  if (!isDonateCookie) {
    uploadSlipStatus.value = 'error';
    uploadError.value = 'เซสชันหมดอายุแล้ว กรุณาเริ่มรายการใหม่เพื่อแนบสลิป';
    return;
  }

  const fd = new FormData();
  fd.append('slipFile', selectedFile.value);
  fd.append('donorid', isDonateCookie.donorid);
  fd.append('idNumber', isDonateCookie.idNumber);

  try {
    await uploadSlip(fd, (uploadEvent) => {
      isUploadSlip.value = true;
      uploadProgressNumber.value = `${Math.round((uploadEvent.loaded / uploadEvent.total) * 100)}%`;
      uploadProgress.value = `width:${uploadProgressNumber.value}`;
    });
    uploadSlipStatus.value = 'success';
    // Uploading a slip no longer marks the donation paid from here. The upload
    // endpoint moves the row to "awaiting review"; only the bank callback at
    // POST /payment/callback may settle a donation.
    setTimeout(() => {
      router.push('/thank-you');
    }, 1000);
  } catch (error) {
    uploadSlipStatus.value = 'error';
    uploadError.value = 'อัปโหลดสลิปไม่สำเร็จ กรุณาลองใหม่อีกครั้ง';
  }
};

// สร้าง QR ตามวิธีจ่ายที่ผู้ใช้เลือก ทุกทางออกต้องปิด spinner และตั้ง qrError
// ไม่งั้นผู้ใช้จะติดอยู่กับ spinner ค้างหรือกล่องเปล่าโดยไปต่อไม่ได้
const setupQRCode = async () => {
  if (isEdonation.value) {
    createEdonatQrcode();
    return;
  }

  const biller = await getBiller(donateInfo.value.bankType);
  if (!biller) {
    failQRCode('ไม่พบข้อมูลบัญชีรับชำระเงิน', 'qr-no-biller');
    return;
  }

  await createQRCode(donateInfo.value, biller.BILLER_ID);
};

const retryQRCode = async () => {
  await setupQRCode();
};

// ทิ้งคุกกี้ที่พังไปด้วย ไม่งั้นรอบหน้าจะอ่าน step2 ค้างก้อนเดิมแล้วพังซ้ำที่เดิม
const restartDonation = () => {
  cookies.remove('donate_info');
  cookies.remove('isDonate');
  router.push('/');
};

// ดักกรณีที่ data URI มาถึงแต่เบราว์เซอร์ปฏิเสธ — สมมติฐานเดียวเรื่อง WebKit ที่ยังตัดออกไม่ได้
const onQRImageError = () => {
  failQRCode('ไม่สามารถแสดง QR Code ได้', 'qr-img-error', describeImageSrc(imageSrc.value));
  imageSrc.value = '';
};

// เว็บเขียนลง gallery โดยตรงไม่ได้ saveImage จะเปิด share sheet ให้ผู้ใช้เลือก
// "บันทึกรูปภาพ" เอง และตกกลับไปดาวน์โหลดปกติเมื่อเครื่องไม่รองรับ
const saveQRCode = async () => {
  await saveImage(imageSrc.value, 'QRCode.png');
};

const startPaymentCheck = () => {
  const checkPaymentId = isEdonation.value 
    ? `0_${donateInfo.value.personal_id.toString()}` 
    : `${donateInfo.value.personal_id.toString()}_${donateInfo.value.mobile_number.toString()}`;

  // Polling drives the UI only. The bank settles the donation server-side via
  // POST /payment/callback, which has already run by the time this resolves.
  paymentInterval = paymentCheck(checkPaymentId, (transactionData) => {
    if (transactionData) {
      disableUpload.value = false;
      isDonate.value = true;
      // ทิ้ง data URI ของ QR ไปเลย ไม่ใช่แค่ซ่อนด้วย CSS เพื่อไม่ให้เหลืออะไร
      // ให้กดบันทึกหรือกดค้างเซฟรูปได้อีกหลังจากที่จ่ายเงินสำเร็จแล้ว
      imageSrc.value = '';
      if (isEdonation.value) {
        donateAmount.value = transactionData.amount;
      }
    }
  });
};

onMounted(async () => {
  window.scrollTo(0, 0);
  const donateInfoCookie = cookies.get('donate_info');
  if (donateInfoCookie) {
    const decrypted = JSON.parse(decryptData(donateInfoCookie));

    // คุกกี้ที่มี step2 แต่ไม่มี step1 เกิดขึ้นได้จริง — DonateMethod เคยเขียนทับแบบนั้น
    // ตอนคุกกี้หมดอายุกลางคัน แก้ที่ต้นทางแล้วแต่คุกกี้ที่พังไปก่อนหน้ายังอยู่ในเครื่อง
    // ผู้บริจาคได้อีก 30 นาที ปล่อยผ่าน = personal_id undefined ไหลไปถึง POST /donate (400)
    if (!decrypted.step1 || !decrypted.step1.personal_id) {
      donorSaveFailed.value = true;
      failQRCode('ข้อมูลผู้บริจาคหมดอายุแล้ว', 'qr-donor-info-missing');
      return;
    }

    donateInfo.value = { ...decrypted.step1, ...decrypted.step2 };
    donateAmount.value = donateInfo.value.amount;
    isEdonation.value = donateInfo.value.bankType === 3;
    disableUpload.value = !isEdonation.value;

    repeat.value = decrypted.repeat || null;

    if (!(await insertDonorToDB(donateInfo.value, repeat.value))) {
      donorSaveFailed.value = true;
      failQRCode('ไม่สามารถบันทึกข้อมูลผู้บริจาคได้', 'qr-donor-insert-failed');
      return;
    }

    // โหมดแนบสลิปย้อนหลัง: เงินเข้าไปแล้ว จึงไม่มีอะไรให้จ่ายและไม่มีอะไรให้รอ
    // ห้ามสร้าง QR (จะกลายเป็นคำเชิญให้จ่ายซ้ำ) และห้าม poll (ธนาคารยืนยันไปแล้ว)
    // updateSlip ไม่แตะสถานะของแถวที่ isdonate=1 อยู่แล้ว สลิปนี้เป็นหลักฐานประกอบล้วน ๆ
    if (isAttachSlipMode.value) {
      isLoading.value = false;
      disableUpload.value = false;
      return;
    }

    await setupQRCode();
    startPaymentCheck();
  } else {
    router.push('/');
  }
});

onUnmounted(() => {
  if (paymentInterval) {
    clearInterval(paymentInterval);
  }
});

</script>

<style scoped></style>